module.exports = __webpack_public_path__ + "static/media/profile.95333243.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/profile.jpg
// module id = 26
// module chunks = 0